document.addEventListener("variant:add", function(event) {
    const CART_COOKIE_KEY = "cart_created";
    console.log(getCookie(CART_COOKIE_KEY));
    if (!getCookie(CART_COOKIE_KEY)) {
        setCookie(CART_COOKIE_KEY, "true", 14); 
        let cart = event.detail.cart; 

        if (cart.items.length === 1) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'creation_panier'
            });

        }
    }
});

function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + "; path=/";
}

function getCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}
